/**
 * Remember PrimaryKeyword from the last viewed PDP and prefill header search inputs
 * until the customer opens another product page.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'azopy:lastPrimaryKeyword';
  const PDP_DATA_ID = 'pdp-primary-keyword-json';

  /**
   * @returns {string}
   */
  function readPdpKeywordFromPage() {
    const el = document.getElementById(PDP_DATA_ID);
    if (!el) return '';

    try {
      const parsed = JSON.parse(el.textContent || '""');
      return typeof parsed === 'string' ? parsed.trim() : '';
    } catch {
      return '';
    }
  }

  function syncStorageFromPdp() {
    if (!document.getElementById(PDP_DATA_ID)) return;

    const keyword = readPdpKeywordFromPage();
    if (keyword) {
      sessionStorage.setItem(STORAGE_KEY, keyword);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  /**
   * @returns {string}
   */
  function getStoredKeyword() {
    try {
      return (sessionStorage.getItem(STORAGE_KEY) || '').trim();
    } catch {
      return '';
    }
  }

  function applyToSearchInputs() {
    const keyword = getStoredKeyword();
    if (!keyword) return;

    document.querySelectorAll('.header-inline-search__input').forEach((input) => {
      if (input.dataset.preserveSearchValue === 'true') return;
      input.value = keyword;
    });
  }

  function run() {
    syncStorageFromPdp();
    applyToSearchInputs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
